
export default {
  getTimeZones: (state) => state.timeZones,
  getLocation: (state) => state.location
};
